import { Button, Empty, EmptyContent, EmptyDescription, EmptyHeader } from '@monksflow/monks-ui';
import { FileIcon, UploadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { EmptyStateTitle } from '@/shared/ui';

interface EmptyCollectionFilesProps {
  onUpload: () => void;
  /** False drops the CTA: there is nothing this viewer could do with it. */
  canUpload: boolean;
}

/**
 * Mirrors the approval folder's empty pane, so the two read as one treatment.
 *
 * The toolbar is gone at this point (nothing to search, no rows to select), so
 * this state carries the only way into the uploader.
 */
export function EmptyCollectionFiles({ onUpload, canUpload }: EmptyCollectionFilesProps) {
  const { t } = useTranslation('knowledge');

  return (
    <Empty role="status" data-testid="collection-files-empty" className="flex-1">
      <EmptyHeader>
        <FileIcon className="size-6 text-muted-foreground" aria-hidden />
        <EmptyStateTitle>{t('knowledgeBases.collectionFilesPane.noFilesYet')}</EmptyStateTitle>
        <EmptyDescription>
          {t('knowledgeBases.collectionFilesPane.noFilesYetDescription')}
        </EmptyDescription>
      </EmptyHeader>
      {canUpload && (
        <EmptyContent>
          <Button variant="default" size="lg" onClick={onUpload}>
            <UploadIcon data-testid="upload-file-icon" />
            {t('knowledgeBases.collectionFilesToolbar.uploadFile')}
          </Button>
        </EmptyContent>
      )}
    </Empty>
  );
}

EmptyCollectionFiles.displayName = 'EmptyCollectionFiles';
